import React, { useCallback, useEffect } from "react";
import InputField from "app/components/InputField";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { MODES } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/containers/Questions/redux/slice";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import DeleteForeverTwoToneIcon from "@mui/icons-material/DeleteForeverTwoTone";
import {
  MixedLetterAnswer,
  OpenTextAnswer,
} from "app/containers/Questions/types";
import { useTranslation } from "react-i18next";
import useDebounceEffect from "utils/hooks/useDebounceEffect";
import CustomTable from "app/components/Table";
import CustomTableRow from "app/components/TableRow";
import PrimaryButton from "app/components/Buttons/PrimaryButton";
import AddIcon from "@mui/icons-material/Add";
import { TableHeaderColumnType } from "app/components/Table/types";
import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import EditableColumn from "app/components/EditableColumn";
interface StyledCellProps {
  minWidth?: string | number;
  maxWidth?: string | number;
}

const StyledTableCell = styled("div")(
  ({ minWidth, maxWidth }: StyledCellProps) => ({
    flex: 1,
    display: "flex",
    alignItems: "center",
    padding: "14px 16px",
    "&:last-of-type": {
      borderRight: "none",
    },
    backgroundColor: "transparent",
    textAlign: "unset",
    whiteSpace: "nowrap",
    height: 50,
    minWidth: minWidth || "auto",
    maxWidth: maxWidth || "none",

    fontSize: "14px",
    lineHeight: "16px",
    color: "#3C3C43",
  })
);

const Headers: TableHeaderColumnType[] = [
  {
    id: "#",
    label: "HASH",
    align: "left",
    minWidth: 200,
    maxWidth: 200,
    sortable: false,
  },
  {
    id: "text",
    label: "ANSWER_TEXT",
    align: "left",
    minWidth: 500,
    maxWidth: 500,
    sortable: false,
  },
  {
    id: "action",
    label: "ACTIONS",
    align: "left",
    minWidth: 200,
    maxWidth: 200,
    sortable: false,
  },
];
const MAX_ANSWER = 10;

const Data: OpenTextAnswer = {
  _id: "",
  answer: "",
};
const OpenText = ({ disabled, mode }: { disabled?: boolean; mode: MODES }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const answer = useSelector(selectAnswer);
  const maxNotReached = (answer.single_select?.length ?? 0) < MAX_ANSWER;

  useDebounceEffect(
    () => {
      if (!answer?.open_text?.length) {
        dispatch(actions.setOpenTextAnswer(Data));
        return;
      }
      return () => {};
    },
    [answer?.open_text],
    100
  );
  const handleAddAnswer = () => {
    if (maxNotReached) {
      dispatch(actions.setOpenTextAnswer(Data));
      return;
    }
  };
  const disabledDelete = answer?.open_text?.length == 1 || disabled;
  return (
    <>
      <CustomTable headers={Headers}>
        {answer?.open_text?.map((item, index) => (
          <CustomTableRow key={index}>
            <StyledTableCell maxWidth={200} minWidth={200}>
              {index == 0
                ? t("QUESTIONS.FORM.LABELS.OPEN_TEXT_ANSWER")
                : t("QUESTIONS.FORM.LABELS.OPEN_TEXT_ACCEPTED_ANSWER", {
                    answer: index ,
                  })}
            </StyledTableCell>
            <StyledTableCell maxWidth={500} minWidth={500}>
            <EditableColumn
                disabled={disabled}
                value={item?.answer || ""}
                
                isOdd={index % 2 === 0}
                innerContainerStyle={{
                  maxWidth: "100%",
                }}
                inputStyle={{
                  background: "transparent",
                }}
                onSave={(e) => {
                  dispatch(
                    actions.setUpdateAnswer({
                      index: index,
                      key: "answer",
                      type: "open_text",
                      value: e,
                    })
                  );
                }}
              />
              
            </StyledTableCell>
            <StyledTableCell maxWidth={200} minWidth={200}>
              <IconButton
                sx={{
                  width: "40px",
                  height: "24px",
                  borderRadius: "4px",
                }}
                disabled={disabledDelete}
                onClick={() => {
                  dispatch(
                    actions.setDeleteAnswer({
                      index: index,
                      type: "open_text",
                    })
                  );
                }}
              >
                <DeleteForeverTwoToneIcon
                  sx={{
                    fontSize: "16px",
                    color: disabledDelete ? "#ccc" : "#E24399",
                  }}
                />
              </IconButton>
            </StyledTableCell>
          </CustomTableRow>
        ))}
        <CustomTableRow key={"add"} style={{ backgroundColor: "#fff" }}>
          <StyledTableCell maxWidth={200} minWidth={200}>
            &nbsp;
          </StyledTableCell>
          <StyledTableCell maxWidth={500} minWidth={500}>
            &nbsp;
          </StyledTableCell>

          <StyledTableCell maxWidth={200} minWidth={200}>
            <PrimaryButton
              sx={{ width: 145 }}
              startIcon={<AddIcon />}
              disabled={!maxNotReached}
              onClick={handleAddAnswer}
              label={t("COMMON.BUTTONS.ADD_NEW_ANSWER")}
            />
          </StyledTableCell>
        </CustomTableRow>
      </CustomTable>
    </>
  );
};

export default OpenText;
